// Because we need another style but follows most tertiary button style
export const notDisabledAndActive = `:not(:disabled):not(.disabled):active, :not(:disabled):not(.disabled).active`;
export const notDisabledAndFocus = `:not(:disabled):not(.disabled):focus, :not(:disabled):not(.disabled).focus`;
